// Promise.withResolvers polyfill (Android WebView fix)
if (!(Promise as any).withResolvers) {
    (Promise as any).withResolvers = function <T>(this: PromiseConstructor) {
        let resolve!: (value: T | PromiseLike<T>) => void;
        let reject!: (reason?: any) => void;

        const promise = new this<T>((res, rej) => {
            resolve = res;
            reject = rej;
        });

        return { promise, resolve, reject };
    };
}
